import { RestModel } from './core/RestModel'

export class BrandModel extends RestModel {
  constructor(data = {}) {
    super(data, {
      name: 'brand',
      endpoint: '/brands',
      schema: {
        id: Number,
        name: String,
        logo: String,
        logoScale: Number,
        order: Number,
        isActive: Boolean,
        isFeatured: Boolean,
        createdAt: String,
        updatedAt: String,
      },
    })
  }
}

export default BrandModel
